export default __webpack_public_path__ + "static/microporous-8b9832dc86c6f3e9431bb9699e0f53da.jpg";